module.exports = __webpack_public_path__ + "icon-applications.c83c632c51cd1167b0e1e60e907241f8.png";